import { ClientsPage } from '@/pages/ClientsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/clients/')({
  component: ClientsPage,
})
